// PostHog wrapper for inaq.sk marketing site.
// Same project as ai.inaq.sk (US region). Gated on cookie consent
// (analytics_consent localStorage flag — set by src/cookieConsent.js).

import posthog from "posthog-js";

let initialized = false;

export function initPostHog() {
  if (initialized) return posthog;
  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key) {
    console.warn("PostHog key missing (REACT_APP_POSTHOG_KEY). Skipping init.");
    return null;
  }

  posthog.init(key, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com",
    ui_host: "https://us.posthog.com",
    person_profiles: "identified_only",
    capture_pageview: false,         // SPA — fire $pageview manually on route change
    capture_pageleave: true,
    autocapture: true,
    session_recording: {
      maskAllInputs: true,
      maskInputOptions: { password: true, email: true },
    },
    loaded: (ph) => {
      if (process.env.NODE_ENV === "development") ph.debug();
    },
  });

  initialized = true;
  console.log("PostHog initialized");
  return posthog;
}

export function trackPostHogPageView(path) {
  if (!initialized) return;
  posthog.capture("$pageview", {
    $current_url: window.location.href,
    path,
  });
}

export function trackPostHogEvent(name, properties = {}) {
  if (!initialized) return;
  posthog.capture(name, properties);
}

export function identifyUser(distinctId, properties = {}) {
  if (!initialized) return;
  posthog.identify(distinctId, properties);
}

export function optOutPostHog() {
  if (!initialized) return;
  posthog.opt_out_capturing();
}

export { posthog };
